import React, { useState } from 'react';
import { RiMenuAddFill } from 'react-icons/ri';
import { FiPlusSquare, FiMinusSquare, FiSearch } from 'react-icons/fi';
import { AiOutlineDelete } from "react-icons/ai";

export const SelectPopup = ({ onClose, onDeleteClickWithData, onShowSuccess }) => {
  const [showLayouts, setShowLayouts] = useState(Array(8).fill(false));
  const [expandedRows, setExpandedRows] = useState({});
  const [topAddClicked, setTopAddClicked] = useState({});

  const data = ['0134', '01345', '0134567'];

  const toggleLayout = (index) => {
    const updated = [...showLayouts];
    updated[index] = !updated[index];
    setShowLayouts(updated);
  };

  const toggleSearch = (outerIdx, innerIdx) => {
    setExpandedRows((prev) => {
      const outer = prev[outerIdx] || {};
      return {
        ...prev,
        [outerIdx]: {
          ...outer,
          [innerIdx]: !outer[innerIdx],
        },
      };
    });
  };

  const handleTopAddClick = (outerIdx) => {
    setTopAddClicked((prev) => ({
      ...prev,
      [outerIdx]: !prev[outerIdx],
    }));

    setShowLayouts((prev) => {
      const updated = [...prev];
      updated[outerIdx] = true;
      return updated;
    });
  };
  return (
    <div className="min-w-[800px] max-h-[450px] space-y-4 border rounded-2xl overflow-auto bg-white p-4">
      <div className="flex justify-between">
        <h1 className="pt-2 pl-2 text-gray-800 text-lg font-semibold">Select Hsn</h1>
        <button onClick={onClose} className="text-gray-600 text-2xl mr-8">&times;</button>
      </div>
      <p className="text-gray-800 text-xs pl-1 flex">You can be able to select only one SAC</p>
      <hr />
      <div className="flex items-center max-w-[550px] p-1 border rounded-md bg-gray-200 mt-5 ml-20">
        <input placeholder="Search" className="flex-1 bg-gray-200 p-1 focus:outline-none" />
        <FiSearch className="text-lg text-gray-600 mr-2" />
      </div>

      {Array.from({ length: 5 }).map((_, outerIdx) => (
        <div key={outerIdx} className="rounded-md">
          <div className="flex gap-2 border-b p-2 items-center ml-8">
            <RiMenuAddFill
              className="text-xl text-gray-600 cursor-pointer"
              onClick={() => handleTopAddClick(outerIdx)}
            />
            <AiOutlineDelete
              className="text-xl text-gray-600 cursor-pointer"
              onClick={() => onDeleteClickWithData?.(`0${outerIdx + 1}`)}
            />
            {showLayouts[outerIdx] ? (
              <FiMinusSquare
                className="text-xl text-blue-500 cursor-pointer"
                onClick={() => toggleLayout(outerIdx)}
              />
            ) : (
              <FiPlusSquare
                className="text-xl text-blue-500 cursor-pointer"
                onClick={() => toggleLayout(outerIdx)}
              />
            )}
            <input type="checkbox" className="w-5 h-5 accent-blue-500" />
            <h1>{`0${outerIdx + 1}`}</h1>
          </div>

          {showLayouts[outerIdx] && (
            <div className="p-3 rounded-md transition-all duration-300">
              <div
                className={`transition-all overflow-hidden duration-300 ms-5 ${
                  topAddClicked[outerIdx]
                    ? 'max-h-[500px] opacity-100 mb-4'
                    : 'max-h-0 opacity-0 mb-0'
                }`}
              >
                <div className="flex border rounded-full w-72 ml-10">
                  <div className="bg-gray-400 rounded-full px-3 flex items-center text-white">
                    <FiSearch className="text-sm" />
                  </div>
                  <input
                    type="text"
                    placeholder=" | 00 enter your SAC code"
                    className="flex-1 rounded text-sm px-2"
                  />
                  <button className="bg-gray-400 text-white p-1 px-4 rounded-r-sm text-sm hover:bg-gray-500">
                    Add
                  </button>
                </div>
              </div>

              {data.map((code, innerIdx) => (
                <div key={innerIdx}>
                  <div className="flex gap-1 p-2 items-center ms-5 ml-10">
                    <RiMenuAddFill
                      className={`text-xl text-gray-600 cursor-pointer ${innerIdx < 2 ? '' : 'invisible'}`}
                      onClick={() => innerIdx < 2 && toggleSearch(outerIdx, innerIdx)}
                    />
                    <AiOutlineDelete
                      className="text-xl text-gray-600 cursor-pointer"
                      onClick={() => onDeleteClickWithData?.(code)}
                    />
                    <FiPlusSquare
                      className="text-xl text-blue-600 cursor-pointer"
                      onClick={() => onDeleteClickWithData?.(code)}
                    />
                    <input type="checkbox" className="w-5 h-5 accent-blue-500" />
                    <h1>{code}</h1>
                  </div>

                  <div
                    className={`transition-all overflow-hidden duration-300 ms-20 ${
                      expandedRows[outerIdx]?.[innerIdx]
                        ? 'max-h-[500px] opacity-100 mb-3'
                        : 'max-h-0 opacity-0 mb-0'
                    }`}
                  >
                    <div className="flex border rounded-full w-72 bg-red-500">
                      <div className="bg-gray-400 rounded-full px-3 flex items-center text-white">
                        <FiSearch className="text-sm" />
                      </div>
                      <input
                        type="text"
                        placeholder=" | 01 enter your SAC code"
                        className="flex-1 rounded text-sm px-2"
                      />
                      <button className="bg-gray-400 text-white p-1 px-4 rounded-r-sm text-sm hover:bg-gray-500">
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}

      <div className="flex justify-end mt-4 pr-2 pt-1">
        <button
  className="bg-blue-600 text-white px-10 py-1 mb-2 rounded"
  onClick={onClose}  // <-- trigger this to go back to SearchPopup
>
  Add
</button>

      </div>
    </div>
  );
};
